import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings';

import LiveStreamingStatsCards from '../../components/LiveStreamingAnalytics/LiveStreamingStatsCards';
import LiveStreamingMonthlyTrend from '../../components/LiveStreamingAnalytics/LiveStreamingMonthlyTrend';
import LiveStreamingM3uFilesPerMonth from '../../components/LiveStreamingAnalytics/LiveStreamingM3uFilesPerMonth';
import LiveStreamingTopPiratedVods from '../../components/LiveStreamingAnalytics/LiveStreamingTopPiratedVods';
import LiveStreamingTopPiratedChannels from '../../components/LiveStreamingAnalytics/LiveStreamingTopPiratedChannels';
import LiveStreamingTopCountries from '../../components/LiveStreamingAnalytics/LiveStreamingTopCountries';
import LiveStreamingTopDomainsAndIsps from '../../components/LiveStreamingAnalytics/LiveStreamingTopDomainsAndIsps';

const LiveStreamingAnalytics = () => {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppHeaderNone(false);
    context.setAppSidebarNone(false);
    context.setAppContentClass('');
    context.setAppThemePanal(true);

    return () => {
      context.setAppHeaderNone(true);
      context.setAppSidebarNone(true);
      context.setAppContentClass('p-0');
      context.setAppThemePanal(false);
    };
  }, [context]);

  return (
    <main>
      <LiveStreamingStatsCards />
      <LiveStreamingMonthlyTrend />
      <LiveStreamingM3uFilesPerMonth />
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <LiveStreamingTopPiratedVods />
        <LiveStreamingTopPiratedChannels />
      </div>
      <LiveStreamingTopCountries />
      <LiveStreamingTopDomainsAndIsps />
    </main>
  );
};

export default LiveStreamingAnalytics;
